'use client';

import { DialogImpl } from './dialog-impl';
import { useDialogStore } from './dialog-store';

export function DialogContainer() {
  const { dialogs } = useDialogStore();
  return (
    <>
      {dialogs.map(dialog => (
        <DialogImpl key={dialog.id} {...dialog} />
      ))}
    </>
  );
}
